/**
 * Converts to compact notation
 * @param {number} value
 * @return {string}
 */
// eslint-disable-next-line import/prefer-default-export
export const toCompactNotation = value => new Intl.NumberFormat('en', { notation: 'compact' }).format(value)
